export default "__VITE_ASSET__e2nGnLb0__"